<template>
  <div class="daily-filter-table">
    <v-data-table :headers="headers" :items="filterDiff" :sort-by="['filter']">
      // eslint-disable-next-line
      <template v-slot:item.diff="{item}">
        <span :class="item.color+'--text'">{{formatPercentage(item.diff)}}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    orders: { type: Array },
    lastWeekOrders: { type: Array },
    filter: { type: Array },
    field: { type: String },
    orderField: { type: String },
    elementField: { type: String },
    filterName: { type: String },
  },
  data: function () {
    return {
      headers: [
        { text: this.filterName, align: "start", value: "filter" },
        { text: "Day", align: "center", value: "current" },
        { text: "Last week", align: "center", value: "lastWeek" },
        { text: "Diff (%)", align: "center", value: "diff" },
      ],
    };
  },
  computed: {
    filterDiff() {
      let res = {};
      for (let [key, value] of Object.entries(this.ordersByFilter)) {
        if (!(key in res)) {
          res[key] = {};
        }
        res[key]["current"] = value.length;
        res[key]["lastWeek"] = 0;
      }
      for (let [key, value] of Object.entries(this.lastWeekOrdersByFilter)) {
        if (!(key in res)) {
          res[key] = {};
        }
        res[key]["lastWeek"] = value.length;
        if (!("current" in res[key])) {
          res[key]["current"] = 0;
        }
      }
      let data = [];
      for (let [key, value] of Object.entries(res)) {
        let diff = null;
        if (value.lastWeek) {
          diff = Math.round(
            ((value.current - value.lastWeek) / value.lastWeek) * 100
          );
        }
        value["diff"] = this.getDiffStyle(diff);
        data.push({
          current: value.current,
          lastWeek: value.lastWeek,
          filter: this.getElementByUuid(key, this.filter, this.field).label,
          diff: value.diff.label,
          color: value.diff.color,
        });
      }
      return data;
    },
    ordersByFilter() {
      return _.chain(this.orders).groupBy(this.orderField).value();
    },
    lastWeekOrdersByFilter() {
      return _.chain(this.lastWeekOrders).groupBy(this.orderField).value();
    },
  },
  methods: {
    getDiffStyle(diff) {
      let label = "-";
      let icon = "mdi-dots-horizontal";
      let color = "grey";
      if (diff < 0) {
        icon = "mdi-arrow-down-bold-circle";
        color = "error";
        label = diff;
      } else if (diff > 0) {
        icon = "mdi-arrow-up-bold-circle";
        color = "success";
        label = diff;
      } else {
        icon = "mdi-arrow-right-bold-circle";
        color = "warning";
        label = diff;
      }
      return {
        label: label,
        icon: icon,
        color: color,
      };
    },
    getElementByUuid(uuid, list, field) {
      let found = list.find((element) => element[this.elementField] == uuid);
      return found ? { label: found[field] } : { label: "unknown" };
    },
    formatPercentage(perc) {
      if (perc > 0) return `+${perc}%`;
      return `${perc}%`;
    },
  },
};
</script>
